import { useEffect, useState } from "react";
import SettingStore from "../../../../store/Setting/Setting.store";
import "../../../../styles/ComponentsStyles/Setting/PathChanger.style.css";
import RightArrowIcon from "../../../../assets/Icons/Setting/NavigationIcons/ArrowRight.svg";
const PathChanger = ({ title, pathName, icon }) => {
  const { currentTab, setCurrentTab } = SettingStore();
  const [isActive, setIsactive] = useState(false);
  useEffect(() => {
    setIsactive(currentTab === pathName);
  }, [pathName, currentTab]);
  return (
    <div
      className={`settingPathChangerBtn ${
        isActive ? "activeSettingPathChangerBtn" : ""
      }`}
    >
      <button
        type="button"
        className="transparentBtn w-full"
        onClick={() => setCurrentTab(pathName)}
      >
        <div className="flex-row align-center justify-start g-1">
          {icon && icon}
          <span className="poppins t-13">{title}</span>
        </div>
        {isActive ? <img src={RightArrowIcon} alt="rightRight" /> : ""}
      </button>
    </div>
  );
};

export default PathChanger;
